import { find, findAll } from "../utils/dom";

const observeSection = () =>{
	const sections = findAll('section');
	if(!sections) return;


	const MenuPrincipal = find('[js-menu-principal]');

	const observer = new IntersectionObserver((entries)=>{
		entries.forEach((entry)=>{
			if(entry.isIntersecting && MenuPrincipal){
				const idSection = entry.target.id;
				const itemMenu = MenuPrincipal.querySelector(`a[href='#${idSection}']`);
				itemMenu?.classList.add("active");

			}
			else{
				const idSection = entry.target.id;
				const itemMenu = MenuPrincipal.querySelector(`a[href='#${idSection}']`);
				itemMenu?.classList.remove("active");
			}
		})
	},
	{ root: null, rootMargin: "0px", threshold: 0.3 }
	);

	sections.forEach((section)=>{
		observer.observe(section);
	});
}

export default observeSection;